module.exports = __webpack_public_path__ + "img/chf.70f62b0c.svg";